module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":{"active":"監視中","inactive":"休止中"}},"en":{"label":{"active":"Active","inactive":"Inactive"}}}')
  delete Component.options._Ctor
}
